import React, { memo } from 'react';
import styled from 'styled-components';

import { largeMediaQuery } from '../../../common/utilities/sizeHelpers';

interface SubnavigationProps {
    isActive: boolean;
    text: string;
    url: string;
    linkToWeb2?: boolean;
}
export const Subnavigation = memo(({ isActive, text, url, linkToWeb2 }: SubnavigationProps) => {
    if (linkToWeb2) {
        return (
            <StyledLink target='_self' active={isActive} href={url}>{text}</StyledLink>
        );
    }
    return (
        <StyledLink active={isActive} href={url}>{text}</StyledLink>
    );
});

Subnavigation.displayName = 'Subnavigation';

interface StyledLinkProps {
    active: boolean;
}

const StyledLink = styled.a<StyledLinkProps>`
    text-align: center;
    font-weight: ${({ active }) => active ? '800' : '400'};
    border-bottom: ${({ active }) =>
        active ? '3px solid rgba(255, 255, 255, 0.9)' : '3px solid rgba(255, 255, 255, 0.2)'};
    transition:
        color .15s ease-in-out,
        border-bottom-color .15s ease-in-out;
    &:hover {
        color: rgba(255, 255, 255, .5);
        border-bottom-color: rgba(255, 255, 255, .5);
    }
    text-decoration: none;
    color: white;
    font-size: 16px;
    width: 88px;
    padding: 14px 20px;
    @media ${largeMediaQuery} {
        padding: 8px 20px;
    }
`;
